import { makeStyles } from "@material-ui/core/styles";

export const newMenuStyles = makeStyles(() => ({
  menuContainer: {
    paddingTop: "15px",
    paddingBottom: "100px",
    backgroundColor: "#FAFBFC",
  },
}));
